// extracted by mini-css-extract-plugin
export default {"container":"gdpTable_container__qfv+W","header":"gdpTable_header__ZB3qh"};